import { render, staticRenderFns } from "./BondStatistics.vue?vue&type=template&id=d0549954&"
import script from "./BondStatistics.vue?vue&type=script&lang=js&"
export * from "./BondStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports